import type { TOC } from '@ember/component/template-only'
import { TilesReporting } from 'teacher-ui-client/components/tiles/reporting'
import { ReportingDashboardHeader } from 'teacher-ui-client/components/tiles/reporting-dashboard/header'
import { NoDataMessage } from 'teacher-ui-client/components/no-data-message'

interface Args {
  title?: string
  tooltip?: string
  empty?: boolean
}
interface Signature {
  Element: Element
  Args: Args
  Blocks: {
    default: unknown[]
  }
}

export const ReportingDashboardStatic: TOC<Signature> = <template>
  {{! Use this when you have a set height for the panel (eg in a grid layout) and the content will expand to meet that height }}
  <TilesReporting class="flex flex-col px-5 pt-4 pb-1" data-test-tiles-reporting-dashboard="static" ...attributes>
    <ReportingDashboardHeader @title={{@title}} @tooltip={{@tooltip}} />
    <div class="shrink grow basis-0">
      {{#if @empty}}
        <NoDataMessage @compact={{true}} class="m-4" />
      {{else}}
        {{yield}}
      {{/if}}
    </div>
  </TilesReporting>
</template>

export default ReportingDashboardStatic
